/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface GetBiasCalculationsApiBiasCalculationsGetRequest {
    xApiKey?: string | null;
}

/**
 * 
 */
export class BiasCalculationsApi extends runtime.BaseAPI {

    /**
     * Get all available bias calculations as id:name mapping
     * Get Bias Calculations
     */
    async getBiasCalculationsApiBiasCalculationsGetRaw(requestParameters: GetBiasCalculationsApiBiasCalculationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bias-calculations/`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all available bias calculations as id:name mapping
     * Get Bias Calculations
     */
    async getBiasCalculationsApiBiasCalculationsGet(requestParameters: GetBiasCalculationsApiBiasCalculationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.getBiasCalculationsApiBiasCalculationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
